module.exports = __webpack_public_path__ + "img/how6.a25b73e2.png";